import axios, { AxiosResponse } from 'axios';
import CONSTANTS from './constants';
import { logError } from '../../index';

const setOrderlistParams = ({ commit }, payload) => {
  commit(CONSTANTS.SET_ORDERLIST_PARAMS, payload);
};
const setSingleOrderParams = ({ commit }, payload) => {
  commit(CONSTANTS.SET_SINGLE_ORDER_PARAMS, payload);
};
const setHidingOrderModules = ({ commit }, payload) => {
  commit(CONSTANTS.SET_HIDING_ORDER_MODULES, payload);
};
const resetOrderData = ({ commit }) => {
  commit(CONSTANTS.RESET_ORDER_DATA);
};

const getSingleOrderData = async ({ commit, state }, payload: any): Promise<unknown> => {
  const { advertiserId, daterange, orderId, method, period } = payload;

  let orderDataCacheUrl = `/api/advertiser/single-order/${method}/${advertiserId}/${orderId}/${daterange}`;
  if (period) {
    orderDataCacheUrl += `/${period}`;
  }
  if (method === 'map-summary') {
    orderDataCacheUrl = `/api/advertiser/${advertiserId}/order/${orderId}/summary/${daterange}`;
  }
  if (method === 'impressions-by-geo-list') {
    orderDataCacheUrl = `/api/order/advertiser/${advertiserId}/order/${orderId}/impressions/geo-list/${daterange}`;
  }

  commit(CONSTANTS.SET_IS_ORDER_DATA_LOADING, { method, isLoading: true });

  const isOrderDataLoadingPath = `${method}IsLoading`;
  const orderDataPath = `${method}Data`;
  const cachePath = `${method}CacheUrl`;

  if (state.orderData[cachePath] === orderDataCacheUrl && state.orderData[orderDataPath]) {
    return state.orderData[orderDataPath];
  }
  try {
    const { data } = await axios.get(orderDataCacheUrl);

    commit(CONSTANTS.SET_ORDER_DATA, { method, data });
    commit(CONSTANTS.SET_ORDER_DATA_CACHE_URL, { method, orderDataCacheUrl });
    return data;
  } catch (exp) {
    throw logError(exp, 'store.performance.getSingleOrderData');
  } finally {
    commit(CONSTANTS.SET_IS_ORDER_DATA_LOADING, { method, isLoading: false });
  }
};

const getSingleOrderCampaignList = async ({ commit, state }, payload: any): Promise<unknown> => {
  const { advertiserId, orderId, tactic, limit, offset, search, campaignStatus } = payload;
  const method = 'campaign-list';
  let filterString = 'sortby=end_asc';
  filterString += `&limit=${limit ?? 5}`;
  filterString += `&offset=${offset ?? '0'}`;
  filterString += `&search=${search ?? ''}`;
  if (campaignStatus && campaignStatus !== 'All') filterString += `&campaignStatus=${campaignStatus}`;
  if (tactic) filterString += `&type=${tactic}`;

  const orderCampaignsCacheUrl = `/api/advertiser/order/campaign-list/${advertiserId}/${orderId}/${filterString}`;
  const orderCampaignsDataPath = `${method}Data`;
  const orderCampaignsCachePath = `${method}CacheUrl`;

  if (state.orderData[orderCampaignsCachePath] === orderCampaignsCacheUrl && state.orderData[orderCampaignsDataPath]) {
    return state.orderData[orderCampaignsDataPath];
  }
  try {
    const { data } = await axios.get(orderCampaignsCacheUrl);

    data.performance = data.performance.filter(obj => obj.type !== 'TV2OTT');

    commit(CONSTANTS.SET_ORDER_DATA, { method, data });
    commit(CONSTANTS.SET_ORDER_DATA_CACHE_URL, { method, orderDataCacheUrl: orderCampaignsCacheUrl });
    commit(CONSTANTS.SET_IS_ORDER_DATA_LOADING, { method, isLoading: true });
    return data;
  } catch (exp) {
    throw logError(exp, 'store.performance.getSingleOrderCampaignList');
  } finally {
    commit(CONSTANTS.SET_IS_ORDER_DATA_LOADING, { method, isLoading: false });
  }
};

export default {
  setOrderlistParams,
  setSingleOrderParams,
  setHidingOrderModules,
  getSingleOrderData,
  getSingleOrderCampaignList,
  resetOrderData,
};
